
import React, { useEffect, useState, useRef } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import useAutosizeTextArea from '../components/useAutosizeTextArea'
import AddIcon from '@mui/icons-material/Add';
import Typography from '@material-ui/core/Typography'
import AppBar from '../components/app-bar'
import ListItem from '@material-ui/core/ListItem'
import paperClip from '../images/paper_clip.svg'
import wepSVG from '../images/web-svgrepo-com.svg'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import iconClean from '../images/icon-clean.svg'
import { customTheme } from '../styling'
import { AppBar as AppBarHistory, Button, TableContainer, Divider, MenuItem, Menu, makeStyles, Popover } from '@material-ui/core'
import axiosInstance from '../axios'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import ChatConfiguration from '../components/dialogs/chat-configuration'
import { Dialog, TextField } from '@mui/material'
import { Close } from '@material-ui/icons'
import { openaiAssistantAsync, openaiAsync, registerCost, toBase64 } from '../utils'
import { useSelector } from 'react-redux';
import moment from 'moment';
import { drawerWidth } from '../components/app-bar'

import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'

const imageRegex = /\.(jpg|jpeg|png|gif)$/i

const speechText = `The speech must be in [English].

You must control the attached file.

From [slide 1 to slide 5, Gianluca Garbi, the CEO], speaks.

From [slide 6 to slide 8, Ilaria Bennati, the CFO], speaks.

From [slide 9 to the end, Gianluca Garbi, the CEO], speaks again.

The speech concludes with:

"Operator, we are now ready to answer any questions from the audience.

Thank you all for your attention.

This presentation's speech was created with the help of artificial intelligence, reproducing my voice in multiple languages."`

const comunicatoStampaText = `Scrivi un comunicato stampa in lingua: Italiano.

Il comunicato deve essere: Dettagliato.

L'obiettivo del comunicato è annunciare: il lancio di un nuovo prodotto finanziario chiamato "PrestitoSicuro".

Titolo: Banca Sistema lancia il nuovo prodotto finanziario "PrestitoSicuro".

Testo introduttivo: Banca Sistema annuncia il lancio di PrestitoSicuro, un nuovo strumento di finanziamento pensato per rispondere ai bisogni specifici delle famiglie italiane.

Che cosa viene annunciato: Il nuovo PrestitoSicuro sarà distribuito sul territorio nazionale attraverso una rete di oltre 100 intermediari certificati. Questo servizio mira a diversificare ulteriormente il portafoglio finanziário della banca e raggiungere nuovi segmenti di mercato.

Nome e Ruolo del Rappresentante: Nicolò Fiorio, Co-Head della Divisione Prodotti.

Dichiarazione: “Questo nuovo lancio rappresenta un passo importante per posizionare Banca Sistema come leader nel settore del finanziamento personale, fornendo soluzioni chiare e mirate per le famiglie italiane.”

Contesto strategico o informazioni di supporto: Secondo uno studio di settore, il mercato potenziale per questo tipo di servizio è stimato in crescita nel prossimo triennio del 25%.

Testo finale: Con PrestitoSicuro, Banca Sistema conferma il proprio impegno nell'innovazione e nella creazione di soluzioni finanziarie accessibili e utili agli italiani.

Data e luogo: Milano, 26 settembre 2024.`

const articoloText = `Sei un modello linguistico avanzato specializzato in nella creazione di articoli strutturati, e abile con la scrittura di contenuti SEO ottimizzati per il web.

Scrivi un articolo sull'argomento [_] dal titolo [_] che ha come obiettivo [_].

Utilizza uno stile coerente con il tono e il sentimento richiesto, mantenendo il focus sull'interesse del pubblico target.

L’articolo deve interessare un pubblico di [_].

L'articolo deve avere la seguente struttura sequenziale: Titolo in H1, introduzione,
almeno [_] sezione/i H2, [_] sezione/i H3 (le sezioni H3 sono sottosezioni degli H2),
conclusione, elenco fonti citate.

Presenta alcune informazioni come elenco puntato. Formatta l’articolo in markdown e,
se necessario, usa delle tabelle. Importante: scrivi una sezione (ad esempio
introduzione), poi fermati e chiedimi se voglio delle modifiche o se puoi proseguire con
la sezione successiva.`

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  topBar: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '1rem',
    paddingLeft: '1rem',
  },
  title: { color: 'black' },

  menuItem: {
    // cor de fundo e texto no hover
    '&:hover': {
      backgroundColor: '#F3F4F6',  // cinza claro
      color: '#111',
    },
  },

  menuPaper: {
    borderRadius: 12,
    // hover para QUALQUER opção
    '& .MuiMenuItem-root:hover': {
      backgroundColor: '#F3F4F6',
      color: '#111',
    },
    // estado selecionado
    '& .MuiMenuItem-root.Mui-selected': {
      backgroundColor: '#EEF2FF',
      color: '#111',
      fontWeight: 600,
    },
    // hover do selecionado
    '& .MuiMenuItem-root.Mui-selected:hover': {
      backgroundColor: '#E5E7EB',
    },
  },

  menuItemRoot: {
    // hover de qualquer opção
    '&.MuiMenuItem-root:hover, &.MuiListItem-button:hover': {
      backgroundColor: '#F3F4F6',
      color: '#111',
    },
    // focus via teclado (opcional)
    '&.Mui-focusVisible': {
      backgroundColor: '#F3F4F6',
      color: '#111',
    },
  },

  menuItemSelected: {
    '&.Mui-selected': {
      backgroundColor: '#EEF2FF',   // selecionado
      color: '#111',
      fontWeight: 600,
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#E5E7EB',   // hover do selecionado
    },
  },

        

  chatSection: { width: '100%' },

  viewport: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight:0,
  },

  viewportCenter: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  messageArea: {
    textAlign: 'left',
    overflowY: 'auto',
    flex: 1,
    padding: '0 2rem',
    minHeight:0,
    paddingBottom: '1rem',
  },

  composerDock: {
    position: 'sticky',
    bottom: 0,
    padding: '8 10px 35px 20px',
    background: 'transparent',
  },

  msgRow: {
    display: 'flex',
    width: '100%',
    marginTop: 12,
  },
  bubbleUser: {
    maxWidth: '80%',
    borderRadius: 12,
    padding: '10px 12px',
    background: customTheme.colors.ui.greyLight,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  bubbleBot: {
    maxWidth: '80%',
    borderRadius: 12,
    padding: '10px 12px',
    background: 'transparent',
    border: '1px solid #E5E7EB',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },

  msgLabel: {
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1,
    marginBottom: 6,
    textTransform: 'uppercase',
    color: '#111',          // padrão (user)
  },
  msgLabelBot: {
    color: '#6b7280',       // tom mais neutro para AI 
  },

  formControl: { minWidth: 280, marginRight: '1rem', height: 50 },
  selectWhite: {
    backgroundColor: '#fff',
    '&:focus': { backgroundColor: '#fff' },
  },

  composerWrap: {
    border: '1px solid #E5E7EB',
    borderRadius: 15,
    background: '#fff',
    padding: '12px 12px 8px 12px',
    width: '100%',
    boxSizing: 'border-box',
    transition: 'border-color .15s ease',
    '&:focus-within': {
      borderColor: customTheme.colors.ui.red
    }
  },
  composerRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 8,
  },
  composerTextarea: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: '1.05rem',
    lineHeight: 1.4,
    background: 'transparent',
    maxHeight: '35vh',
    minHeight: '10vh',
    paddingRight: 8,
  },
  composerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 8,
    marginBottom: 4,
    position: 'relative',
  },
  pill: {
    border: '1px solid #D1D5DB',
    borderRadius: 10,
    padding: '6px 10px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    color: '#6b7280',
    cursor: 'pointer'
  },
  pillActive: {
    borderColor: '#B91F26',
    color: '#B91F26',
    filter: 'brightness(100%)'
  },

  emptyStateCenter: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 20,
    // backgroundColor:'red'
  },

  typingRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 10,
  },
  typingText: {
    fontSize: '1.1rem',
    color: '#808080',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#9CA3AF',
    display: 'inline-block',
    animation: '$blink 1s infinite ease-in-out',
  },
  dot2: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#9CA3AF',
    display: 'inline-block',
    animation: '$blink 1s infinite ease-in-out',
    animationDelay: '0.2s',
  },
  dot3: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#9CA3AF',
    display: 'inline-block',
    animation: '$blink 1s infinite ease-in-out',
    animationDelay: '0.4s',
  },
  '@keyframes blink': {
    '0%, 80%, 100%': { opacity: 0.3, transform: 'scale(0.8)' },
    '40%': { opacity: 1, transform: 'scale(1)' },
  },
}));

const TypingDots = ({ classes }) => (
  <Box className={classes.typingRow}>
    <span className={classes.typingText}>Sto scrivendo</span>
    <span className={classes.dot} />
    <span className={classes.dot2} />
    <span className={classes.dot3} />
  </Box>
)

const ChatComposer = ({
  classes,
  chatText,
  setChatText,
  generatingAnswer,
  files,
  setFiles,
  typeOfChat,
  searchWeb,
  setSearchWeb,
  onSend,
  inputRef
}) => {
  const onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (chatText?.trim() || (files && files.length)) onSend();
    }
  };

  const pickFiles = (e) => {
    e.preventDefault();
    inputRef?.current?.click();
  };

  return (
    <Box className={classes.composerWrap}>
      <div className={classes.composerRow}>
        <textarea
          className={classes.composerTextarea}
          placeholder="Scrivi il tuo messaggio"
          disabled={generatingAnswer}
          rows={4}
          value={chatText || ''}
          onChange={(e) => setChatText(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </div>

      <div className={classes.composerActions}>
        <input
          multiple
          ref={inputRef}
          type="file"
          hidden
          accept={['Chat', 'Chat Mini'].includes(typeOfChat) ? 'image/*' : '.pdf,.docx,.doc'}
          onClick={(e) => { e.target.value = null }}
          onChange={(e) => {
            const picked = Array.from(e.target.files || []);
            setFiles(picked);
          }}
        />
        {files?.length > 0 && (
          <Box style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
            {files.map((f, i) => (
              f.name.match(/\.(jpg|jpeg|png|gif)$/i)
                ? <Box key={i} style={{ position:'relative' }}>
                    <img alt="" src={URL.createObjectURL(f)} style={{ width:64, height:64, objectFit:'cover', borderRadius:8 }} />
                    <Button
                      size="small"
                      onClick={() => setFiles(files.filter((_, idx) => idx !== i))}
                      style={{
                        position: 'absolute',
                        top: 1,
                        right: 1,
                        width: 16,
                        height: 16,
                        minWidth: 16,
                        padding: 0,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 10,
                        fontWeight: 'bold',
                        lineHeight: 1,
                      }}
                    >
                      x
                    </Button>
                  </Box>
                : <Box key={i} style={{ padding:'1px 8px 1px 12px', border:'1px solid #d84e4eff', borderRadius:10 }}>
                    {f.name}
                    <Button size="small" onClick={() => setFiles(files.filter((_,idx)=>idx!==i))} style={{ marginLeft:8, minWidth:24, borderRadius:6, backgroundColor:'white' }}>x</Button>
                  </Box>
            ))}
          </Box>
        )}
        {files?.length > 0 && (
          <Button
            size="small"
            onClick={() => setFiles([])}
            style={{
              textDecoration: 'underline',
              padding: 0,
              minWidth: 'auto',
              background: 'transparent',
              boxShadow: 'none',
              color: '#B91F26',
              marginRight:40,
              marginLeft:40,
            }}
          >
            Rimuovi tutti
          </Button>
        )}
        <Box className={classes.pill} onClick={pickFiles}>
          <img src={paperClip} alt="" />
          <span>Immagine/documento</span>
        </Box>

        {typeOfChat === 'Chat' && (
          <Box
            className={`${classes.pill} ${searchWeb ? classes.pillActive : ''}`}
            onClick={() => !generatingAnswer && setSearchWeb(!searchWeb)}
          >
            <img
              src={wepSVG}
              alt=""
              style={{
                width: 16,
                height: 16,
                marginRight: 6,
                filter: searchWeb
                  ? 'invert(14%) sepia(92%) saturate(6095%) hue-rotate(350deg) brightness(82%) contrast(94%)'
                  : 'grayscale(100%) brightness(0) invert(45%)'
              }}
            />
            <span>Searchweb</span>
          </Box>
        )}

        <Button
          color="primary"
          variant="contained"
          disabled={generatingAnswer || (!chatText?.trim() && (!files || files.length === 0))}
          onClick={() => (chatText?.trim() || (files && files.length)) && onSend()}
          style={{ height: 40, borderRadius: 10, position: 'absolute', right: 0 }}
        >
          Invia
        </Button>
      </div>
    </Box>
  );
};

const Chat = () => {
  const { enqueueSnackbar } = SnackBar.Consumer()
  const history = useHistory()
  const inputRef = useRef(null)
  const classes = useStyles();
  const [chat, setChat] = useState([])
  const [generatingAnswer, setGeneratingAnswer] = useState(false)
  const [typeOfChat, setTypeOfChat] = useState('Chat')
  const [searchWeb, setSearchWeb] = useState(false)
  const [savingConfguration, setSavingConfguration] = useState(false)
  const [files, setFiles] = useState([])
  const [system, setSystem] = useState(0)
  const [openChatConfiguration, setOpenChatConfiguration] = useState(false)
  const [historyChatOpen, setHistoryChatOpen] = useState(false)
  const [chatText, setChatText] = useState('')
  const [saveChatModal, setSaveChatModal] = useState(false)
  const [savedChatName, setSavedChatName] = useState('')
  const [chatCustomizations, setChatCustomizations] = useState([])
  const [historyChat, setHistoryChat] = useState([])
  const [customChat, setCustomChat] = useState('')
  const [nameChat, setNameChat] = useState('')
  const [descriptionChat, setDescriptionChat] = useState('')
  const [anchorCustomChat, setAnchorCustomChat] = React.useState(null)
  const [savedChats,  setSavedChats] = useState([])
  const { drawerOpen } = useSelector((state) => state.ui)
  const [userDetails, setUserDetails] = useState(null)
  const [personaKey, setPersonaKey] = useState('');
  const [openTypeOfChat, setOpenTypeOfChat] = useState(false)
  const [openPersona, setOpenPersona] = useState(false)
  const [anchorMore, setAnchorMore] = useState(null)
  const [activeMsgIdx, setActiveMsgIdx] = useState(null)

  const [anchorEl2, setAnchorEl2] = useState(null);
  const handleClickPopover2 = (event) => setAnchorEl2(event.currentTarget);
  const handleClosePopover2 = () => setAnchorEl2(null);
  const open2 = Boolean(anchorEl2)
  const id2 = open2 ? 'simple-popover' : undefined

  const initialData = async () => {
    try {
      const res1 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/chats`)
      const res2 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/chats/customizations`)
      return [...res1.data.payload.chats.map((res) => ({...res, type:0})), ...res2.data.payload.chat_customizations.map((res) => ({...res, type:1}))]
    } catch (error) {}
  }

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`).then((res) => {
      setUserDetails(res.data.payload)
    }).catch(() => {})
    initialData().then((res) => setSavedChats(res)).catch(() => {})
  }, [])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const customChatId = Number(urlParams.get('customChatId'))
    const chatId = Number(urlParams.get('chatId'))
    if(customChatId){
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/chats/customizations/${customChatId}`).then((res) => {
        setCustomChat(res)
      }).catch(() => {})
    } else if(chatId){
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/chats/${chatId}`).then((res) => {
        const savedChat = res.data.payload.chat.chat_messages.map((res, index) => {
          return { type: index % 2 == 0 ? 0 : 1, text: res.message }
        })
        setNameChat(res.data.payload.chat.name)
        setChat(savedChat)
      }).catch(() => {})
    }
  }, [location.search])


  const handleSend = async () => {
    const message = (chatText || '').trim();
    const currentFiles = files;

    const images = currentFiles.filter((f) => f.name.match(imageRegex));
    const filesApplication = currentFiles.filter((f) => !f.name.match(imageRegex));

    if (!message && images.length === 0 && filesApplication.length === 0) return;

    // empilha a mensagem do usuário
    const userMsg = currentFiles.length
      ? { type: 0, text: message, images, files: filesApplication }
      : { type: 0, text: message };

    setChat((prev) => [...prev, userMsg]);

    // limpa inputs
    setChatText('');
    setFiles([]);

    setGeneratingAnswer(true);

    try {
      // Fluxo SPEECH
      if (typeOfChat === 'Scrivi Speech') {
        let completion = null;
        if (filesApplication.length) {
          completion = await openaiAssistantAsync('asst_GIvzDBR243hV4GZUdxglXDRA', message, filesApplication[0]);
        } else {
          completion = await openaiAssistantAsync('asst_GIvzDBR243hV4GZUdxglXDRA', message);
        }

        let finalText = '';

        for await (const chunk of completion) {
          // texto em stream
          if (chunk?.event === 'thread.message.delta') {
            const piece = chunk.data?.delta?.content?.[0]?.text?.value || '';
            finalText += piece;

            setChat((prev) => {
              const arr = [...prev];
              // se o último não for a resposta ainda, adiciona um novo
              if (arr[arr.length - 1]?.type !== 1) {
                return [...arr, { type: 1, text: finalText }];
              }
              // senão, atualiza o último
              arr[arr.length - 1] = { type: 1, text: finalText };
              return arr;
            });
          }

          // custo no final do run
          if (chunk?.event === 'thread.run.completed') {
            try {
              const total = Number(chunk.data?.usage?.total_tokens) || 0;
              const uid = userDetails?.id;
              if (uid && total > 0) {
                await registerCost(0, 'SPEECH', uid, total);
              }
            } catch (e) {
              console.warn('registerCost falhou (SPEECH):', e?.response?.status, e?.response?.data || e?.message);
            }
          }
        }

        return; // encerra aqui o fluxo SPEECH
      }

      // Fluxo CHAT / CHAT MINI / COMUNICATO / ARTICOLO
      const imagesBase64 = await Promise.all(images.map(toBase64));
      let kind = typeOfChat;
      if (searchWeb) kind = 'Chat - Search Web';

      const completion = await openaiAsync(chat, message, kind, imagesBase64);

      let finalText = '';

      for await (const chunk of completion) {
        // texto em stream
        if (chunk?.choices?.[0]?.delta?.content) {
          finalText += chunk.choices[0].delta.content;

          setChat((prev) => {
            const arr = [...prev];
            if (arr[arr.length - 1]?.type !== 1) {
              return [...arr, { type: 1, text: finalText }];
            }
            arr[arr.length - 1] = { type: 1, text: finalText };
            return arr;
          });
        }

        // custo durante o stream (se a API emitir usage por chunk)
        if (chunk?.usage) {
          try {
            const functionalitys = {
              'Chat': 'CHAT STANDARD',
              'Chat Mini': 'CHAT MINI',
              'Comunicato stampa': 'PRESS RELEASE',
              'Scrivi articolo': 'CHAT STANDARD',
              'Chat - Search Web': 'CHAT STANDARD',
            };
            const total = Number(chunk.usage.total_tokens) || 0;
            const uid = userDetails?.id;
            const feature = functionalitys[kind] || 'CHAT';

            if (uid && total > 0) {
              await registerCost(0, feature, uid, total);
            }
          } catch (e) {
            console.warn('registerCost falhou (CHAT):', e?.response?.status, e?.response?.data || e?.message);
          }
        }
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE });
    } finally {
      setGeneratingAnswer(false);
    }
  };

  useEffect(() => {
    const el = document.getElementById('messageAreaId')
    if (el) el.scrollTop = el.scrollHeight
  }, [chat, generatingAnswer])

  const handleSaveConfiguration = async () => {
    setSavingConfguration(true)
    try {
      const body = { name: nameChat, content: descriptionChat }
      const system = await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/chats/customizations/`, body)
      setOpenChatConfiguration(false)
      enqueueSnackbar({ variant: 'success', message: 'Configurazione salvata correttamente' })
      history.push(`/chat?id=${system.data.id}`)
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setSavingConfguration(false)
    }
  }

  const chatMapping = { 'Chat': 0, 'Chat Mini': 1, 'Comunicato stampa': 2, 'Speech': 3 }

  const handleSaveChat = async () => {
    const body = {
      name: savedChatName,
      chat_customization_id: typeOfChat === 'Chat' ? 0 : typeOfChat === 'Chat Mini' ? 1 : null,
      kind: chatMapping[typeOfChat],
      chat_messages_attributes: chat.map((chat) => {
        const data = chat.images ? toBase64(chat.images[0]) : chat.files ? toBase64(chat.images[0]) : null
        return {
          message: chat.text,
          kind: chat.type,
          chat_attachment_attributes: data && { kind: chat?.images?.length ? 0 : 1, data }
        }
      })
    }

    try {
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/chats`, body)
      setSaveChatModal(false)
      const res = await initialData()
      setSavedChats(res)
      enqueueSnackbar({ variant: 'success', message: 'Chat salvata correttamente' })
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    }
  }

  const handleClearChat = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const customChatId = Number(urlParams.get('customChatId'))
    const chatId = Number(urlParams.get('chatId'))
    if(chatId || customChatId){
      setNameChat(null)
      history.push('/chat')
    }
    setChat([])
    setNameChat(null)
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClickTypeOfChat = (event) => setAnchorEl(event.currentTarget)
  const handleCloseTypeOfChat = () => setAnchorEl(null);
  const open = Boolean(anchorEl)

  const handleClickCustomChat = (event) => {
    ['Chat', 'Chat Mini'].includes(typeOfChat) && setAnchorCustomChat(event.currentTarget);
  };
  const handleCloseCustomOption = () => setAnchorCustomChat(null);
  const openCustomChat = Boolean(anchorCustomChat)

  const handleDownloadCartaIntestata = async (type, text) => {
    const body = { "template": type, "text": text }
    try {
      const response  = await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/render_template`, body, { responseType: 'blob' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(response.data)
      link.download = `${type}-${moment().format('YYYY-MM-DD HH:mm')}.docx`
      link.click()
    } catch (error) {
      enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
    }
  }


  const allowedTypeOptions = [
  userDetails?.enable_chat && 'Chat',
  userDetails?.enable_chat_mini && 'Chat Mini',
  userDetails?.enable_pressrelease && 'Comunicato stampa',
  userDetails?.enable_article && 'Scrivi articolo',
  userDetails?.enable_speech && 'Scrivi Speech',
  ].filter(Boolean)

  const safeTypeOfChat = allowedTypeOptions.includes(typeOfChat) ? typeOfChat : ''

  
  const personaOptions = savedChats.map(({id, name, type}) => `${id}::${name}`)
  const safePersonaKey = personaOptions.includes(personaKey) ? personaKey : ''

  return (
    <AppBar>
      {openChatConfiguration && <ChatConfiguration
        nameChat={nameChat}
        setNameChat={setNameChat}
        descriptionChat={descriptionChat}
        setDescriptionChat={setDescriptionChat}
        handleClose={() => {
          setDescriptionChat(null)
          setNameChat(null)
          setOpenChatConfiguration(false)
        }}
        handleSaveConfiguration={handleSaveConfiguration}
        savingConfguration={savingConfguration}
      />}

      {saveChatModal &&
        <Dialog open={saveChatModal} 
          PaperProps={{ style: { borderRadius: 15 } }}
        >
          <Box style={{ width: '400px', height: '250px', padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'center', borderRadius:15 }}>
            <Typography variant='h5'>Salva la chat</Typography>
            <TextField 
              helperText='Campo obbligatorio' 
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '15px' } }}
              style={{ marginTop: '1.5rem' }} 
              placeholder='Nome della chat' 
              value={savedChatName || ''} 
              onChange={(event) => setSavedChatName(event.target.value)} 
            />
            <Box style={{ marginTop: '1.5rem' }}>
              <Button onClick={() => setSaveChatModal(false)} variant='contained' style={{ marginRight: '1rem' }} >Annulla</Button>
              <Button disabled={!savedChatName} onClick={() => savedChatName && handleSaveChat()} color='primary' variant='contained'>Salva</Button>
            </Box>
          </Box>
        </Dialog>
      }

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Box className={classes.topBar}>
          <Typography className={classes.title} variant="h5" component="h2">
            Chat Assistant
          </Typography>

          <Box style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {chat.length > 0 &&
              <Box onClick={() => setSaveChatModal(true)} style={{ color: customTheme.colors.ui.green, marginRight: '0.5rem', cursor: 'pointer', fontSize: '1.1rem' }}>
                Salva chat
              </Box>
            }
            {chat.length > 0 &&
              <Box onClick={handleClearChat} style={{ color: customTheme.colors.ui.red, marginRight: '1.5rem', cursor: 'pointer', fontSize: '1.1rem' }}>
                <img style={{ position: 'relative', top: '0.3rem' }} src={iconClean} /> Pulisci chat
              </Box>
            }

            <FormControl className={classes.formControl} variant="outlined" style={{ backgroundColor: 'white' }}>
              <Select
                classes={{ select: classes.selectWhite }}
                displayEmpty
                value={safeTypeOfChat}
                open={openTypeOfChat}
                onOpen={() => setOpenTypeOfChat(true)}
                onClose={() => setOpenTypeOfChat(false)}
                onChange={(e) => {
                  const val = e.target.value
                  setFiles([])
                  if (val === 'Comunicato stampa') setChatText(comunicatoStampaText)
                  else if (val === 'Scrivi articolo') setChatText(articoloText)
                  else if (val === 'Scrivi Speech') setChatText(speechText)
                  else setChatText('')
                  setTypeOfChat(val)
                  setNameChat(null)
                }}
                IconComponent={KeyboardArrowDownIcon}
                renderValue={(val) => (
                  <Box style={{ width: '100%', textAlign: 'right', color: val ? '#111' : '#9CA3AF' }}>
                    {val || 'Chat/attività'}
                  </Box>
                )}
                input={
                  <OutlinedInput
                    notched={false}
                    style={{ borderRadius: 15, display: 'flex', height: '100%', cursor: 'pointer' }}
                    onMouseDown={(e) => { e.preventDefault(); setOpenTypeOfChat(true) }}
                    startAdornment={
                      <InputAdornment position="start" style={{ marginRight: 8 }}>
                        <span style={{ color: '#6b7280' }}>Chat/attività</span>
                      </InputAdornment>
                    }
                  />
                }
                MenuProps={{
                  classes: { paper: classes.menuPaper }, 
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                }}
              >
                {allowedTypeOptions.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
              </Select>
            </FormControl>

            <FormControl className={classes.formControl} variant="outlined" style={{ backgroundColor: 'white', cursor: 'pointer' }}>
              <Select
                classes={{ select: classes.selectWhite }}
                displayEmpty
                value={safePersonaKey}
                open={openPersona}
                onOpen={() => setOpenPersona(true)}
                onClose={() => setOpenPersona(false)}
                onChange={(e) => {
                  const chosen = e.target.value
                  if (chosen === '__new__') {
                    setNameChat(null)
                    setOpenChatConfiguration(true)
                    return
                  }
                  const [idStr] = chosen.split('::')
                  const id = Number(idStr)
                  const found = savedChats.find(sc => sc.id === id)
                  if (found) {
                    setChat([])
                    setPersonaKey(`${found.id}::${found.name}`)
                    setNameChat(found.name)
                    if (found.type) history.push(`chat?customChatId=${found.id}`)
                    else history.push(`chat?chatId=${found.id}`)
                  } else {
                    setNameChat(null)
                    history.push('/chat')
                  }
                }}
                IconComponent={KeyboardArrowDownIcon}
                renderValue={(val) => {
                  if (!val) return <Box style={{ textAlign:'right', color:'#9CA3AF' }}>Chat/personalità</Box>
                  const [, display] = String(val).split('::')
                  return <Box style={{ textAlign:'right', color:'#111' }}>{display}</Box>
                }}
                input={
                  <OutlinedInput
                    notched={false}
                    style={{ borderRadius: 15, display: 'flex', height: '100%', cursor: 'pointer' }}
                    onMouseDown={(e) => { e.preventDefault(); setOpenPersona(true) }}
                    startAdornment={
                      <InputAdornment position="start" style={{ marginRight: 8 }}>
                        <span style={{ color: '#6b7280' }}>Chat/personalità</span>
                      </InputAdornment>
                    }
                  />
                }
                MenuProps={{
                  classes: { paper: classes.menuPaper }, 
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                }}
              >
                <MenuItem value="__new__"  className={classes.menuItem} classes={{ root: classes.menuItemRoot, selected: classes.menuItemSelected }}>
                  <AddIcon fontSize="small" style={{ marginRight: 6 }} /> Crea nuova personalità
                </MenuItem>
                <Divider />
                {savedChats.map(({ id, name, type }) => (
                  <MenuItem key={`${type}-${id}`} value={`${id}::${name}`}  className={classes.menuItem} classes={{ root: classes.menuItemRoot, selected: classes.menuItemSelected }}>{name}</MenuItem>

                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        
        <Divider />

        <Box
          className={`${classes.viewport} ${(!generatingAnswer && chat.length === 0) ? classes.viewportCenter : ''}`}
        >
          {(!generatingAnswer && chat.length === 0) && (
            <Box className={classes.emptyStateCenter}>
              <Typography variant="h5" style={{ color: '#111' }}>
                Come posso esserti utile?
              </Typography>
              <Typography style={{ color: '#6b7280' }}>
                Seleziona un’attività che vuoi svolgere oppure scrivi direttamente il tuo messaggio nella chat
              </Typography>

              <Box style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                <Button
                  variant="outlined"
                  disabled={!userDetails?.enable_article}
                  style={{
                    borderRadius: 20,
                    borderColor: typeOfChat === 'Scrivi articolo' ? '#B91F26' : '#E5E7EB',
                    color: typeOfChat === 'Scrivi articolo' ? '#B91F26' : '#111'
                  }}
                  onClick={() => { setChatText(articoloText); setTypeOfChat('Scrivi articolo') }}
                >
                  Scrivi articolo
                </Button>

                <Button
                  variant="outlined"
                  disabled={!userDetails?.enable_pressrelease}
                  style={{
                    borderRadius: 20,
                    borderColor: typeOfChat === 'Comunicato stampa' ? '#B91F26' : '#E5E7EB',
                    color: typeOfChat === 'Comunicato stampa' ? '#B91F26' : '#111'
                  }}
                  onClick={() => { setChatText(comunicatoStampaText); setTypeOfChat('Comunicato stampa') }}
                >
                  Scrivi comunicato stampa
                </Button>

                <Button
                  variant="outlined"
                  disabled={!userDetails?.enable_speech}
                  style={{
                    borderRadius: 20,
                    borderColor: typeOfChat === 'Scrivi Speech' ? '#B91F26' : '#E5E7EB',
                    color: typeOfChat === 'Scrivi Speech' ? '#B91F26' : '#111'
                  }}
                  onClick={() => { setChatText(speechText); setTypeOfChat('Scrivi Speech') }}
                >
                  Scrivi speech
                </Button>
              </Box>

              <Box style={{ width: '60%', minWidth: 520, marginTop: 20 }}>
                <ChatComposer
                  classes={classes}
                  chatText={chatText}
                  setChatText={setChatText}
                  generatingAnswer={generatingAnswer}
                  files={files}
                  setFiles={setFiles}
                  typeOfChat={typeOfChat}
                  searchWeb={searchWeb}
                  setSearchWeb={setSearchWeb}
                  onSend={handleSend}
                  inputRef={inputRef}
                />
              </Box>
            </Box>
          )}

          {(chat.length > 0 || generatingAnswer) && (
            <>
              <Box id="messageAreaId" className={classes.messageArea}>
                <Box style={{ width: '100%' }}>
                  {chat.map((ch, index) => (
                    <Box
                      key={`${index}-${ch.text?.slice(0, 10)}`}
                      className={classes.msgRow}
                      style={{ justifyContent: ch.type === 0 ? 'flex-end' : 'flex-start' }}
                    >
                      <Box className={ch.type === 0 ? classes.bubbleUser : classes.bubbleBot}>
                        <Box className={`${classes.msgLabel} ${ch.type === 1 ? classes.msgLabelBot : ''}`}>
                          {ch.type === 0 ? 'TU' : 'AI'}
                        </Box>
                        {/* Attachments */}
                        {Array.isArray(ch.images) && ch.images.length > 0 && (
                          <Box style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                            {ch.images.map((img, i) => (
                              <img
                                key={i}
                                alt=""
                                src={URL.createObjectURL(img)}
                                style={{ width: 96, height: 96, objectFit: 'cover', borderRadius: 8 }}
                              />
                            ))}
                          </Box>
                        )}

                        {Array.isArray(ch.files) && ch.files.length > 0 && (
                          <ul style={{ margin: '0 0 8px 0', padding: 0, listStyle: 'none' }}>
                            {ch.files.map((f, i) => (
                              <li key={i} style={{ fontSize: 12, color: '#6b7280' }}>{f.name}</li>
                            ))}
                          </ul>
                        )}

                        <Typography variant="body2" style={{ color: '#111', fontSize: '1.05rem' }}>
                          {ch.text}
                        </Typography>
                      </Box>

                      {ch.type === 1 && !generatingAnswer && (
                        <>
                          <MoreVertIcon
                            onClick={(e) => { setAnchorMore(e.currentTarget); setActiveMsgIdx(index) }}
                            style={{ cursor: 'pointer', marginLeft: 8, color: '#9CA3AF', marginTop: 10 }}
                          />
                          <Popover
                            open={Boolean(anchorMore) && activeMsgIdx === index}
                            anchorEl={anchorMore}
                            onClose={() => { setAnchorMore(null); setActiveMsgIdx(null) }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                          >
                            <Box style={{ padding: '1.2rem 1rem 1rem 1rem' }}>
                              <span style={{ fontWeight: 'bold' }}>Scarica:</span>
                              <Box style={{ display: 'flex', flexDirection: 'column', lineHeight: 2.2, marginTop: '0.5rem' }}>
                                <Button
                                  onClick={() => handleDownloadCartaIntestata('letterhead', ch.text)}
                                  style={{ justifyContent: 'left', paddingLeft: 0 }}
                                >
                                  Carta Intestata BS
                                </Button>
                                <Button
                                  onClick={() => handleDownloadCartaIntestata('pressrelease_it', ch.text)}
                                  style={{ justifyContent: 'left', paddingLeft: 0 }}
                                >
                                  Comunicato Stampa BS ita
                                </Button>
                                <Button
                                  onClick={() => handleDownloadCartaIntestata('pressrelease_en', ch.text)}
                                  style={{ justifyContent: 'left', paddingLeft: 0 }}
                                >
                                  Comunicato Stampa BS eng
                                </Button>
                              </Box>
                            </Box>
                          </Popover>
                        </>
                      )}
                    </Box>
                  ))}

                  {generatingAnswer && (
                    <ListItem style={{ marginTop: '1rem', paddingLeft: 0 }}>
                      <Box style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
                        <TypingDots classes={classes} />
                      </Box>
                    </ListItem>
                  )}
                </Box>
              </Box>

              <Box className={classes.composerDock}>
                <ChatComposer
                  classes={classes}
                  chatText={chatText}
                  setChatText={setChatText}
                  generatingAnswer={generatingAnswer}
                  files={files}
                  setFiles={setFiles}
                  typeOfChat={typeOfChat}
                  searchWeb={searchWeb}
                  setSearchWeb={setSearchWeb}
                  onSend={handleSend}
                  inputRef={inputRef}
                />
              </Box>
            </>
          )}
        </Box>

    

      </main>
    </AppBar>
  )
}

export default Chat